module.exports = __webpack_public_path__ + "img/section_bg_3.0fbc51af.png";